import {type FC, useEffect, useState} from 'react';
import WeatherApi from '../../../apis/callWeatherApi.ts';
import {Col, Container, DateTimeText, Row} from './Weather.styled.ts';
import {useFocusable} from '@noriginmedia/norigin-spatial-navigation';

const Weather: FC = () => {
    const [temp, setTemp] = useState<string>('');
    const [icon, setIcon] = useState<string>('04d');

    const {ref, focused} = useFocusable({
        focusKey: 'weather',
    });
    const fetchData = async () => {
        try {
            const res = await WeatherApi.getCurrentWeather(import.meta.env.VITE_LOC_LAT, import.meta.env.VITE_LOC_LON);
            setTemp(Math.round(res.main.temp * 10) / 10 + '');
            const iconModule = await import(`../../../assets/images/${res.weather[0].icon}.png`);
            setIcon(iconModule.default);
        } catch (e: any) {
            const iconModule = await import(`../../../assets/images/04d.png`);
            setIcon(iconModule.default);
            setTemp('20.1');
            console.error('키를 다시 확인해 주세요.', e);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const [currentTime, setCurrentTime] = useState(new Date());
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);
        const updateWeather = setInterval(() => {
            fetchData();
        }, 3600000);

        return () => {
            clearInterval(timer);
            clearInterval(updateWeather);
        };
    }, []);

    const weekdays = ['일', '월', '화', '수', '목', '금', '토'];
    const year = currentTime.getFullYear();
    const month = (currentTime.getMonth() + 1).toString().padStart(2, '0');
    const day = currentTime.getDate().toString().padStart(2, '0');
    const weekday = weekdays[currentTime.getDay()];
    const hours = currentTime.getHours().toString().padStart(2, '0');
    const minutes = currentTime.getMinutes().toString().padStart(2, '0');
    const seconds = currentTime.getSeconds().toString().padStart(2, '0');

    return (
        <Container ref={ref} $focused={focused}>
            <Row style={{alignItems: 'flex-start'}}>
                <Col size={7} style={{display: 'grid', textAlign: 'right'}}>
                    <DateTimeText>
                        {year}/{month}/{day}
                    </DateTimeText>
                    <DateTimeText>({weekday}요일)</DateTimeText>
                </Col>
                {/*<Col size={5} style={{textAlign: "center", fontSize:"1rem"}}>{hours}:{minutes}:{seconds}</Col>*/}
                <Col size={5} style={{textAlign: 'center'}}>
                    <img style={{width: '1rem'}} src={icon} alt="weather_icon" />
                </Col>
            </Row>
            <Row>
                <Col size={12} style={{textAlign: 'center', fontSize: '1rem'}}>
                    {temp}°<sup>c</sup>
                </Col>
            </Row>
        </Container>
    );
};
export default Weather;
